// src/pages/Login.js - JUSTE LE SWITCH MODIFIÉ
import React, { useState, useEffect, useRef } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import countryCodes, { getCountryByCode } from "../data/countryCodes";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost/securecontrol-backend";

const Login = () => {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [formErrors, setFormErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [inputType, setInputType] = useState("email");
  const [showCountrySelector, setShowCountrySelector] = useState(false);
  
  const [selectedCountry, setSelectedCountry] = useState(getCountryByCode("NE"));
  
  const dropdownRef = useRef(null);
  const phoneInputRef = useRef(null);

  const navigate = useNavigate();

  const primaryColor = "#0B3C5D";
  const primaryHover = "#1E88C8";
  const accentColor = "#4FC3F7";
  const bgColor = "#F5F7FA";
  const textColor = "#2E2E2E";
  const borderColor = "#e0e0e0";

  // Fermer le dropdown quand on clique ailleurs
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowCountrySelector(false);
      }
    };
    
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Charger les informations sauvegardées
  useEffect(() => {
    const token = localStorage.getItem("access_token");
    if (token) {
      navigate("/dashboard");
    }
    
    const savedRememberMe = localStorage.getItem("remember_me") === "true";
    setRememberMe(savedRememberMe);
    
    if (savedRememberMe) {
      const savedUsername = localStorage.getItem("saved_username");
      
      if (savedUsername) {
        if (savedUsername.includes("@")) {
          setInputType("email");
          setEmail(savedUsername);
        } else if (savedUsername.includes("+")) {
          setInputType("phone");
          const countryMatch = countryCodes.find(country => 
            savedUsername.startsWith(country.code)
          );
          if (countryMatch) {
            setSelectedCountry(countryMatch);
            const numberOnly = savedUsername.replace(countryMatch.code, "").trim().replace(/[^\d]/g, '');
            setPhoneNumber(numberOnly);
          }
        }
      }
    }
  }, [navigate]);

  // Basculer entre email et téléphone - VERSION CORRIGÉE (comme mobile)
  const toggleInputType = () => {
    if (inputType === "email") {
      setInputType("phone");
      setEmail("");
      setTimeout(() => {
        phoneInputRef.current?.focus();
      }, 100);
    } else {
      setInputType("email");
      setPhoneNumber("");
    }
  };

  // Sélectionner un pays
  const handleSelectCountry = (country) => {
    setSelectedCountry(country);
    setShowCountrySelector(false);
    setTimeout(() => {
      phoneInputRef.current?.focus();
    }, 100);
  };

  // Valider le formulaire
  const validateForm = () => {
    let errors = {};
    
    if (inputType === "email") {
      if (!email.trim()) {
        errors.login = "L'email est requis";
      } else if (!/\S+@\S+\.\S+/.test(email)) {
        errors.login = "Email invalide";
      }
    } else {
      if (!phoneNumber.trim()) {
        errors.login = "Le numéro de téléphone est requis";
      } else if (phoneNumber.replace(/\D/g, '').length < 8) {
        errors.login = "Numéro de téléphone trop court";
      }
    }
    
    if (!password.trim()) errors.password = "Le mot de passe est requis";
    else if (password.length < 4) errors.password = "Mot de passe trop court";
    
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    if (!validateForm()) {
      setLoading(false);
      return;
    }

    try {
      const url = `${API_BASE_URL}/auth/login.php`;
      
      let loginData;
      if (inputType === "email") {
        loginData = {
          login: email.trim(),
          password: password
        };
      } else {
        const fullPhoneNumber = selectedCountry.code + phoneNumber.replace(/\D/g, '');
        loginData = {
          login: fullPhoneNumber,
          password: password
        };
      }

      console.log("Tentative de connexion à:", url);
      console.log("Données envoyées:", loginData);

      const response = await axios.post(url, loginData, {
        headers: {
          'Content-Type': 'application/json'
        }
      });

      const data = response.data;
      console.log("Réponse reçue:", data);

      if (!data.success) {
        setError(data.message || "Erreur de connexion");
        setLoading(false);
        return;
      }

      if (!data.access || !data.user) {
        setError("Réponse incomplète du serveur");
        setLoading(false);
        return;
      }

      // Stockage des tokens et infos utilisateur
      localStorage.setItem("access_token", data.access);
      localStorage.setItem("refresh_token", data.refresh || "");
      localStorage.setItem("user", JSON.stringify(data.user));
      
      // Gestion de "Se souvenir de moi"
      if (rememberMe) {
        localStorage.setItem("remember_me", "true");
        localStorage.setItem("saved_username", 
          inputType === "email" ? email.trim() : selectedCountry.code + phoneNumber.replace(/\D/g, '')
        );
      } else {
        localStorage.removeItem("remember_me");
        localStorage.removeItem("saved_username");
      }
      
      // Configuration d'axios pour les prochaines requêtes
      axios.defaults.headers.common["Authorization"] = `Bearer ${data.access}`;

      // Redirection
      navigate("/dashboard");

    } catch (err) {
      console.error("Erreur détaillée:", err);
      
      if (err.response) {
        const { status, data } = err.response;
        
        if (data?.error_code === "account_deleted") {
          setError("Ce compte a été supprimé.");
        } else if (data?.error_code === "account_disabled") {
          setError("Votre compte est désactivé.");
        } else if (data?.error_code === "invalid_credentials" || status === 401) {
          setError("Identifiant ou mot de passe incorrect.");
        } else if (data?.error_code === "missing_fields") {
          setError("Tous les champs sont requis.");
        } else {
          setError(data?.message || `Erreur ${status}: ${data?.error_code || "inconnue"}`);
        }
      } else if (err.request) {
        setError("Impossible de joindre le serveur. Vérifiez que WAMP est démarré.");
      } else {
        setError("Erreur de configuration: " + err.message);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleRememberMeChange = (e) => {
    const isChecked = e.target.checked;
    setRememberMe(isChecked);
    
    if (!isChecked) {
      localStorage.removeItem("saved_username");
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  // Gérer la saisie du téléphone (chiffres uniquement)
  const handlePhoneChange = (e) => {
    const value = e.target.value;
    const numbersOnly = value.replace(/\D/g, '');
    setPhoneNumber(numbersOnly);
  };

  return (
    <div className="auth-shell">
      {/* Panneau de marque (masqué sur petits écrans via CSS) */}
      <div className="auth-visual">
        <div className="auth-visual-glow" />
        <div className="auth-visual-content">
          <div className="auth-visual-brand">
            <div className="auth-visual-logo">
              <img src="/assets/img/secureLogo.png" alt="SecureControle" />
            </div>
            <span className="auth-visual-brand-name">SecureControle</span>
          </div>

          <div className="auth-trial-badge">
            <i className="bi bi-stars"></i> 14 jours d'essai gratuit, sans engagement
          </div>

          <h2>La sécurité de vos sites, pilotée depuis un seul endroit.</h2>
          <p>
            Rondes, incidents, tâches, stock et facturation : tout votre
            dispositif de gardiennage centralisé et suivi en temps réel.
          </p>
          <ul className="auth-visual-points">
            <li><i className="bi bi-geo-alt"></i> Suivi des rondes et des agents sur le terrain</li>
            <li><i className="bi bi-exclamation-triangle"></i> Incidents remontés avec photo et localisation</li>
            <li><i className="bi bi-clipboard-check"></i> Tâches validées avant clôture</li>
            <li><i className="bi bi-credit-card"></i> Abonnement payable directement par myNITA ou Amana</li>
          </ul>

          <div className="auth-payment-row">
            <span className="auth-payment-label">Paiements acceptés</span>
            <div className="auth-payment-logos">
              <img src="/assets/img/mynita_logo.png" alt="myNITA" />
              <img src="/assets/img/amana_logo.png" alt="Amana" />
            </div>
          </div>
        </div>
        <div className="auth-visual-footer">
          <i className="bi bi-shield-check"></i> Sécurité garantie · Service cloud
        </div>
      </div>

      {/* Panneau formulaire */}
      <div className="auth-form-side">
      <div style={{
        width: '100%',
        maxWidth: '450px',
        padding: '20px'
      }}>
        {/* Header avec logo (visible seulement sur petits écrans, le panneau de marque prenant le relai sur desktop) */}
        <div className="text-center mb-4 auth-mobile-header">
          <div className="mb-4">
            <div className="d-inline-flex align-items-center justify-content-center mb-3" style={{
              width: '70px',
              height: '70px',
              borderRadius: '18px',
              overflow: 'hidden'
            }}>
              <img
                src="/assets/img/secureLogo.png"
                alt="SecureControle Logo"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'contain'
                }}
              />
            </div>
            <h1 style={{
              color: primaryColor,
              fontWeight: '700',
              fontSize: '1.8rem',
              marginBottom: '6px',
              lineHeight: '1.2'
            }}>
              SecureControle
            </h1>
          </div>
        </div>

        {/* Carte de connexion */}
        <div className="card mb-4" style={{
          backgroundColor: 'white',
          border: `1px solid ${borderColor}`,
          borderRadius: '16px',
          boxShadow: '0 20px 48px -12px rgba(11, 60, 93, 0.18)',
          width: '100%',
          overflow: 'hidden'
        }}>
          <div className="card-body p-4">
            <div className="text-center mb-4">
              <h5 style={{ 
                color: primaryColor,
                fontWeight: '600',
                marginBottom: '6px',
                fontSize: '1.1rem'
              }}>
                <i className="bi bi-door-open me-2" style={{ color: accentColor, fontSize: '1rem' }}></i>
                Connexion à votre compte
              </h5>
              <p style={{ 
                color: textColor,
                opacity: 0.7,
                fontSize: '0.85rem',
                marginBottom: '0'
              }}>
                Utilisez votre email ou numéro de téléphone
              </p>
            </div>

            {error && (
              <div className="alert alert-danger mb-4 alert-dismissible fade show" style={{ 
                backgroundColor: '#ffebee',
                borderColor: '#f44336',
                color: '#c62828',
                borderRadius: '8px',
                borderLeft: '4px solid #f44336',
                padding: '12px',
                fontSize: '0.85rem',
                marginBottom: '20px'
              }}>
                <div className="d-flex align-items-center">
                  <i className="bi bi-exclamation-triangle me-2" style={{ fontSize: '1rem' }}></i>
                  <div className="flex-grow-1">{error}</div>
                  <button 
                    type="button" 
                    className="btn-close" 
                    onClick={() => setError("")}
                    style={{ fontSize: '0.75rem' }}
                  ></button>
                </div>
              </div>
            )}

            <form onSubmit={handleLogin} noValidate style={{ width: '100%' }}>
              
              {/* ✅ NOUVEAU SWITCH - Style mobile */}
              <div style={{
                display: 'flex',
                backgroundColor: '#f0f0f0',
                borderRadius: '30px',
                padding: '4px',
                marginBottom: '20px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
              }}>
                <button
                  type="button"
                  onClick={() => {
                    if (inputType !== "email") {
                      setInputType("email");
                      setPhoneNumber("");
                    }
                  }}
                  disabled={loading}
                  style={{
                    flex: 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '10px 16px',
                    borderRadius: '26px',
                    gap: '8px',
                    border: 'none',
                    backgroundColor: inputType === "email" ? primaryColor : 'transparent',
                    color: inputType === "email" ? 'white' : '#666',
                    fontWeight: inputType === "email" ? 'bold' : '600',
                    fontSize: '14px',
                    cursor: loading ? 'not-allowed' : 'pointer',
                    transition: 'all 0.3s ease'
                  }}
                >
                  <i className="bi bi-envelope" style={{ fontSize: '16px' }}></i>
                  E-mail
                </button>

                <button
                  type="button"
                  onClick={() => {
                    if (inputType !== "phone") {
                      setInputType("phone");
                      setEmail("");
                      setTimeout(() => {
                        phoneInputRef.current?.focus();
                      }, 100);
                    }
                  }}
                  disabled={loading}
                  style={{
                    flex: 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '10px 16px',
                    borderRadius: '26px',
                    gap: '8px',
                    border: 'none',
                    backgroundColor: inputType === "phone" ? primaryColor : 'transparent',
                    color: inputType === "phone" ? 'white' : '#666',
                    fontWeight: inputType === "phone" ? 'bold' : '600',
                    fontSize: '14px',
                    cursor: loading ? 'not-allowed' : 'pointer',
                    transition: 'all 0.3s ease'
                  }}
                >
                  <i className="bi bi-phone" style={{ fontSize: '16px' }}></i>
                  Téléphone
                </button>
              </div>

              {/* Champ Email/Téléphone (inchangé) */}
              <div className="mb-3">
                <label className="form-label" style={{ 
                  color: textColor,
                  fontWeight: '500',
                  fontSize: '0.85rem',
                  marginBottom: '8px',
                  display: 'block'
                }}>
                  <i className={`bi ${inputType === 'email' ? 'bi-envelope' : 'bi-phone'} me-1`} style={{ color: accentColor, fontSize: '0.9rem' }}></i>
                  {inputType === 'email' ? 'Adresse email' : 'Numéro de téléphone'} <span className="text-danger">*</span>
                </label>
                
                <div className="input-group" style={{ position: 'relative', flexWrap: 'nowrap', width: '100%' }} ref={dropdownRef}>
                  {inputType === 'phone' && (
                    <>
                      <button
                        type="button"
                        className="input-group-text"
                        onClick={() => setShowCountrySelector(!showCountrySelector)}
                        style={{
                          backgroundColor: bgColor,
                          borderColor: formErrors.login ? '#f44336' : borderColor,
                          color: textColor,
                          borderRight: 'none',
                          borderRadius: '8px 0 0 8px',
                          padding: '10px 12px',
                          fontSize: '0.9rem',
                          cursor: 'pointer',
                          minWidth: '80px',
                          flexShrink: 0,
                          whiteSpace: 'nowrap',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          gap: '6px'
                        }}
                      >
                        <span style={{ fontSize: '1.1rem' }}>{selectedCountry.flag}</span>
                        <span style={{ fontWeight: '500' }}>{selectedCountry.code.replace('+', '')}</span>
                        <i className="bi bi-chevron-down" style={{ fontSize: '0.8rem' }}></i>
                      </button>
                      
                      {showCountrySelector && (
                        <div style={{
                          position: 'absolute',
                          top: 'calc(100% + 4px)',
                          left: 0,
                          zIndex: 1000,
                          backgroundColor: 'white',
                          border: `1px solid #d1e3ff`,
                          borderRadius: '8px',
                          boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                          maxHeight: '250px',
                          overflowY: 'auto',
                          width: '220px'
                        }}>
                          {countryCodes.map((country) => (
                            <button
                              key={country.code}
                              type="button"
                              className="btn btn-light w-100 text-start border-0 rounded-0"
                              onClick={() => handleSelectCountry(country)}
                              style={{
                                padding: '10px 15px',
                                fontSize: '0.9rem',
                                backgroundColor: selectedCountry.code === country.code ? '#f0f7ff' : 'transparent',
                                color: textColor,
                                borderBottom: '1px solid #f0f0f0',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '10px'
                              }}
                              onMouseEnter={(e) => {
                                e.target.style.backgroundColor = '#f0f7ff';
                              }}
                              onMouseLeave={(e) => {
                                e.target.style.backgroundColor = selectedCountry.code === country.code ? '#f0f7ff' : 'transparent';
                              }}
                            >
                              <span style={{ fontSize: '1.2rem', minWidth: '30px' }}>{country.flag}</span>
                              <span style={{ fontWeight: '500', minWidth: '50px' }}>{country.code}</span>
                              <span style={{ fontSize: '0.85rem', opacity: 0.8 }}>{country.name}</span>
                            </button>
                          ))}
                        </div>
                      )}
                      
                      <span className="input-group-text" style={{
                        backgroundColor: 'transparent',
                        borderColor: formErrors.login ? '#f44336' : borderColor,
                        borderLeft: 'none',
                        borderRight: 'none',
                        color: textColor,
                        padding: '10px 5px',
                        fontSize: '0.9rem',
                        fontWeight: '500',
                        flexShrink: 0
                      }}>
                        +
                      </span>
                    </>
                  )}

                  <input
                    ref={inputType === 'phone' ? phoneInputRef : null}
                    type={inputType === 'email' ? "email" : "text"}
                    className={`form-control ${formErrors.login ? "is-invalid" : ""}`}
                    value={inputType === 'email' ? email : phoneNumber}
                    onChange={inputType === 'email' ? (e) => setEmail(e.target.value) : handlePhoneChange}
                    disabled={loading}
                    placeholder={inputType === 'email' ? "votre@email.com" : "7 12 34 56 78"}
                    style={{
                      borderColor: formErrors.login ? '#f44336' : borderColor,
                      borderRadius: inputType === 'phone' ? '0 8px 8px 0' : '8px',
                      color: textColor,
                      padding: '10px 12px',
                      fontSize: '0.9rem',
                      height: '44px',
                      borderLeft: inputType === 'phone' ? 'none' : undefined,
                      minWidth: 0,
                      flex: '1 1 auto',
                      width: '100%'
                    }}
                    maxLength={inputType === 'phone' ? 15 : undefined}
                  />
                </div>
                
                {inputType === 'phone' && (
                  <div style={{
                    fontSize: '0.75rem',
                    color: '#666',
                    marginTop: '4px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    gap: '8px'
                  }}>
                    <span style={{ minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                      Numéro complet : <strong>{selectedCountry.code}{phoneNumber || '...'}</strong>
                    </span>
                    <span style={{ flexShrink: 0 }}>{phoneNumber.length}/15</span>
                  </div>
                )}
                
                {formErrors.login && (
                  <div className="invalid-feedback d-block mt-1" style={{ color: '#f44336', fontSize: '0.8rem' }}>
                    <i className="bi bi-exclamation-circle me-1"></i>
                    {formErrors.login}
                  </div>
                )}
              </div>

              {/* Champ Mot de passe (inchangé) */}
              <div className="mb-4">
                <label htmlFor="password" className="form-label" style={{ 
                  color: textColor,
                  fontWeight: '500',
                  fontSize: '0.85rem',
                  marginBottom: '6px',
                  display: 'block'
                }}>
                  <i className="bi bi-lock me-1" style={{ color: accentColor, fontSize: '0.9rem' }}></i>
                  Mot de passe <span className="text-danger">*</span>
                </label>
                <div className="input-group">
                  <span className="input-group-text" style={{ 
                    backgroundColor: bgColor,
                    borderColor: formErrors.password ? '#f44336' : borderColor,
                    color: formErrors.password ? '#f44336' : accentColor,
                    borderRight: 'none',
                    borderRadius: '8px 0 0 8px',
                    padding: '10px 12px',
                    fontSize: '0.9rem'
                  }}>
                    <i className="bi bi-key"></i>
                  </span>
                  <input
                    type={showPassword ? "text" : "password"}
                    className={`form-control ${formErrors.password ? "is-invalid" : ""}`}
                    id="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    disabled={loading}
                    placeholder=""
                    style={{ 
                      borderColor: formErrors.password ? '#f44336' : borderColor,
                      color: textColor,
                      padding: '10px 12px',
                      fontSize: '0.9rem',
                      height: '44px',
                      borderRight: 'none',
                      borderRadius: '0'
                    }}
                  />
                  <button
                    type="button"
                    className="input-group-text"
                    onClick={togglePasswordVisibility}
                    disabled={loading}
                    style={{ 
                      backgroundColor: bgColor,
                      borderColor: formErrors.password ? '#f44336' : borderColor,
                      color: accentColor,
                      borderLeft: 'none',
                      borderRadius: '0 8px 8px 0',
                      padding: '10px 12px',
                      cursor: loading ? 'not-allowed' : 'pointer',
                      transition: 'all 0.2s ease',
                      height: '44px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                    onMouseEnter={(e) => {
                      if (!loading) {
                        e.target.style.backgroundColor = '#e8f4fd';
                        e.target.style.color = primaryColor;
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!loading) {
                        e.target.style.backgroundColor = bgColor;
                        e.target.style.color = accentColor;
                      }
                    }}
                  >
                    <i className={`bi ${showPassword ? 'bi-eye-slash' : 'bi-eye'}`}></i>
                  </button>
                </div>
                {formErrors.password && (
                  <div className="invalid-feedback d-block mt-1" style={{ color: '#f44336', fontSize: '0.8rem' }}>
                    <i className="bi bi-exclamation-circle me-1"></i>
                    {formErrors.password}
                  </div>
                )}
              </div>

              {/* Options avec "Se souvenir de moi" */}
              <div className="d-flex justify-content-between align-items-center mb-4" style={{ fontSize: '0.85rem' }}>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="rememberMe"
                    checked={rememberMe}
                    onChange={handleRememberMeChange}
                    disabled={loading}
                    style={{
                      borderColor: rememberMe ? primaryColor : borderColor,
                      backgroundColor: rememberMe ? primaryColor : 'white',
                      cursor: loading ? 'not-allowed' : 'pointer',
                      width: '16px',
                      height: '16px',
                      transition: 'all 0.2s ease'
                    }}
                  />
                  <label 
                    className="form-check-label" 
                    htmlFor="rememberMe"
                    style={{ 
                      color: rememberMe ? primaryColor : textColor,
                      fontSize: '0.85rem',
                      cursor: loading ? 'not-allowed' : 'pointer',
                      marginLeft: '6px',
                      fontWeight: rememberMe ? '500' : '400',
                      transition: 'all 0.2s ease'
                    }}
                  >
                    Se souvenir de moi
                  </label>
                </div>
                <Link 
                  to="/forgot-password" 
                  className="text-decoration-none"
                  style={{ 
                    color: primaryColor,
                    fontSize: '0.85rem',
                    fontWeight: '500'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.color = primaryHover;
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.color = primaryColor;
                  }}
                >
                  <i className="bi bi-question-circle me-1"></i>
                  Mot de passe oublié ?
                </Link>
              </div>

              {/* Bouton de connexion */}
              <div className="d-grid mb-4">
                <button 
                  type="submit" 
                  className="btn fw-semibold"
                  disabled={loading}
                  style={{
                    backgroundColor: loading ? '#B0BEC5' : primaryColor,
                    borderColor: loading ? '#B0BEC5' : primaryColor,
                    color: 'white',
                    padding: '12px',
                    borderRadius: '8px',
                    fontSize: '0.95rem',
                    transition: 'all 0.3s ease',
                    opacity: loading ? 0.8 : 1,
                    height: '48px'
                  }}
                  onMouseEnter={(e) => {
                    if (!loading) {
                      e.target.style.backgroundColor = primaryHover;
                      e.target.style.borderColor = primaryHover;
                      e.target.style.transform = 'translateY(-2px)';
                      e.target.style.boxShadow = '0 4px 8px rgba(11, 60, 93, 0.2)';
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (!loading) {
                      e.target.style.backgroundColor = primaryColor;
                      e.target.style.borderColor = primaryColor;
                      e.target.style.transform = 'translateY(0)';
                      e.target.style.boxShadow = 'none';
                    }
                  }}
                >
                  {loading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" style={{ width: '1rem', height: '1rem' }}></span>
                      Connexion en cours...
                    </>
                  ) : (
                    <>
                      <i className="bi bi-box-arrow-in-right me-2"></i>
                      Se connecter
                    </>
                  )}
                </button>
              </div>
              
              {/* Ligne séparatrice */}
              <div className="position-relative text-center my-4">
                <hr style={{ 
                  borderColor: borderColor, 
                  opacity: 0.5,
                  margin: '20px 0'
                }} />
                <span style={{ 
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  backgroundColor: 'white',
                  padding: '0 12px',
                  color: textColor,
                  fontSize: '0.8rem',
                  opacity: 0.7,
                  whiteSpace: 'nowrap'
                }}>
                  Nouveau sur SecureControle ?
                </span>
              </div>
              
              {/* Lien inscription */}
              <div className="text-center">
                <Link 
                  to="/register" 
                  className="btn fw-semibold"
                  style={{
                    color: primaryColor,
                    border: `1px solid ${primaryColor}`,
                    backgroundColor: 'transparent',
                    padding: '10px',
                    borderRadius: '8px',
                    fontSize: '0.9rem',
                    width: '100%',
                    transition: 'all 0.3s ease',
                    height: '44px'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = primaryColor;
                    e.target.style.color = 'white';
                    e.target.style.transform = 'translateY(-2px)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = 'transparent';
                    e.target.style.color = primaryColor;
                    e.target.style.transform = 'translateY(0)';
                  }}
                >
                  <i className="bi bi-person-plus me-2"></i>
                  Créer un nouveau compte
                </Link>
              </div>
            </form>
          </div>
        </div>
        
        {/* Footer */}
        <div className="text-center" style={{ width: '100%' }}>
          <div style={{ 
            color: textColor,
            opacity: 0.6,
            fontSize: '0.8rem',
            lineHeight: '1.4'
          }}>
            <div className="mb-2">
              <i className="bi bi-shield-check me-1" style={{ color: primaryColor, fontSize: '0.9rem' }}></i>
              <strong style={{ color: primaryColor }}>Sécurité garantie</strong> • 
              <span className="mx-1">•</span>
              <i className="bi bi-cloud-check me-1" style={{ color: accentColor, fontSize: '0.9rem' }}></i>
              <span>Service cloud</span>
            </div>
            <p className="mb-0" style={{ fontSize: '0.8rem' }}>
              © {new Date().getFullYear()}{' '}
              <a href="https://icontinuum.net/" target="_blank" rel="noopener noreferrer">
                IContinuum
              </a> . Tous droits réservés.
            </p>
          </div>
        </div>
      </div>
      </div>
    </div>
  );
};

export default Login;